// Webpack Imports
// import * as bootstrap from "bootstrap";
import Dropdown from "bootstrap/js/dist/dropdown";
import BaseComponent from "bootstrap/js/dist/base-component.js";
import Collapse from "bootstrap/js/dist/collapse";
import Modal from "bootstrap/js/dist/modal";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import Backdrop from "bootstrap/js/dist/util/backdrop";
import Popover from "bootstrap/js/dist/popover";
import Tab from "bootstrap/js/dist/tab";
import * as util from "bootstrap/js/dist/util";
// import * as dom from 'bootstrap/js/dist/dom';

// Drives My Account modal interactions
// import { myAccountModal } from './js/utility-js/myaccount-modal.js';

// Drives Bootstrap Form Operations that need init before using (such as validation)
import { bsForms } from "./js/utility-js/bs-forms.js";

// Aqui library & utils for address validation
var aqui = "";
var addressUtil = "";

// timer for 10 s

function loadAddressScripts() {
  import("./js/address-js/aqui.js").finally(() => {
    aqui = aqui;
    import("./js/address-js/address-util.js").finally(() => {
      addressUtil = window.addressUtil;
      var fwdElement = document.querySelector(
        ".wf-floating-address-check.receive-aid-param"
      );
       
      if (typeof redirectBasedOnAid === "function" && fwdElement) {
        setTimeout(() => {redirectBasedOnAid(getParameterByName("aid"));}, 250);
      }
    });
  });
}

setTimeout(() => {
  loadAddressScripts();
}, 5000);

document.addEventListener("click", function (e) {
  if (
    e.target.matches(".tt-input") ||
    e.target.matches("button[data-bs-target='#addressCheckerModal']")
  ) {
    if (aqui !== "" && addressUtil !== "") {
      return;
    }
    loadAddressScripts();
  }
});

(function () {
  "use strict";

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });
})();

// This function is not on live site, not sure it is needed
// function onScroll (evt) {
//   // Store the scroll value for laterz.
//   lastScrollY = window.scrollY;

//   // Prevent multiple rAF callbacks.
//   if (scheduledAnimationFrame)
//     return;

//   scheduledAnimationFrame = true;
//   requestAnimationFrame(readAndUpdatePage);
// }

// window.addEventListener('scroll', onScroll);
